"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPanel = exports.SHeaderTitle = exports.SHeader = exports.SCloseIcon = exports.SBody = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _NavigationClose = _interopRequireDefault(require("../../Icons/NavigationClose"));
const SPanel = exports.SPanel = _styledComponents.default.div.withConfig({
  displayName: "styles__SPanel",
  componentId: "sc-1k8kr5d-0"
})(["position:relative;&::before{content:", ";width:0;height:0;border-style:solid;border-width:0 10px 10px;border-color:transparent transparent ", " transparent;position:absolute;top:-10px;right:25px;}"], ({
  hasConnector
}) => hasConnector ? '' : 'none', ({
  theme
}) => theme.colors.panel.connectorBg);
const SHeader = exports.SHeader = _styledComponents.default.header.withConfig({
  displayName: "styles__SHeader",
  componentId: "sc-1k8kr5d-1"
})(["height:40px;background:", ";text-align:center;border-radius:2px 2px 0 0;position:relative;padding:0 25px;"], ({
  theme
}) => theme.colors.panel.headerBg);
const SHeaderTitle = exports.SHeaderTitle = _styledComponents.default.span.withConfig({
  displayName: "styles__SHeaderTitle",
  componentId: "sc-1k8kr5d-2"
})(["font-size:", ";font-weight:", ";font-family:", ";line-height:", ";letter-spacing:", ";color:", ";text-transform:", ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;display:block;"], ({
  theme
}) => theme.panel.fontSize, ({
  theme
}) => theme.panel.fontWeight, ({
  theme
}) => theme.panel.fontFamily, ({
  theme
}) => theme.panel.lineHeight, ({
  theme
}) => theme.panel.letterSpacing, ({
  theme
}) => theme.colors.panel.headerText, ({
  theme
}) => theme.panel.textTransform);
const SCloseIcon = exports.SCloseIcon = (0, _styledComponents.default)(_NavigationClose.default).withConfig({
  displayName: "styles__SCloseIcon",
  componentId: "sc-1k8kr5d-3"
})(["bottom:auto;top:50%;transform:translateY(-50%);cursor:pointer;position:absolute;right:10px;fill:", ";&:hover{opacity:0.5;}"], ({
  theme
}) => theme.colors.panel.icon);
const SBody = exports.SBody = _styledComponents.default.div.withConfig({
  displayName: "styles__SBody",
  componentId: "sc-1k8kr5d-4"
})(["border-style:solid;border-color:", ";border-width:", ";border-radius:0 0 3px 3px;display:flex;flex-direction:column;", ""], ({
  theme
}) => theme.colors.panel.border, ({
  isPopupContainer
}) => isPopupContainer ? 0 : '1px', ({
  isPopupContainer,
  theme
}) => isPopupContainer && `
    box-shadow: ${theme.colors.panel.bodyShadow}
  `);